import { mapGetters } from 'vuex'
import { get } from 'lodash'

export default {
  ...mapGetters(['professional']),
  isTitleOfSpecialization () {
    return get(this.type_specialization, 'key', '') === 'T'
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/specializations/form/resources/computed.js